import { authorizedAxios } from 'config/axios';

const FACTUARY_URL = '/factuary/api/v1';

export const fetchFacts = () => {
  return authorizedAxios.get(`${FACTUARY_URL}/facts`);
};
